import $ from 'jquery';

export default function footerTag(){
	$(document).ready(function(){
		
		function sortArrayCloseToTarget(array, target) {
			array.sort((a, b) => a.w - b.w);

			let left = 0;
			let right = array.length - 1;

			const result = [];

			while (left < right) {
				result.push(array[right]);
				result.push(array[left]);
				left++;
				right--;
			}

			if (left === right) {
				result.push(array[left]);
			}

			return result;
		}

		var unsortedArray = [];

		const targetSum = $("#footertags").clientWidth;
		$("#footertags").children().each(function(){
			let _this = $(this);
			let el = {
				e: _this.clone(),
				w: _this.width()
			}
			unsortedArray.push(el)
		})
		const sortedArray = sortArrayCloseToTarget(unsortedArray, targetSum);
		
		$("#footertags").html("");
		for (let nel of sortedArray ){
			nel.e.css("display", "inline-block");
			$("#footertags").append(nel.e);
		}
		$("#footertags").addClass("flexible");
		
	});
}
